
import team2_sub1_act_1_01 from "./team2_sub1_act_1_01.png";
import team2_sub1_act_1_02 from "./team2_sub1_act_1_02.jpg";
import team2_sub1_act_2_01 from "./team2_sub1_act_2_01.jpg";
import team2_sub1_act_2_02 from "./team2_sub1_act_2_02.jpg";
import team2_sub2_act_2_01 from "./team2_sub2_act_2_01.jpg";
import team2_sub2_act_3_01 from "./team2_sub2_act_3_01.jpg";
import team2_sub2_act_4_01 from "./team2_sub2_act_4_01.jpg";
import team2_sub2_act_8_01 from "./team2_sub2_act_8_01.jpg";

export const imgInstructionTeam2 = {
	team2_sub1_act_1_01,
	team2_sub1_act_1_02,
	team2_sub1_act_2_01,
	team2_sub1_act_2_02,
	team2_sub2_act_2_01,
	team2_sub2_act_3_01,
	team2_sub2_act_4_01,
	team2_sub2_act_8_01
}